module.exports = __webpack_public_path__ + "img/fiend_2.fc9984fe.png";